import React from 'react';
import { Helmet } from 'react-helmet-async';
import Home from './Home';

const Home_en = () => (
  <div className="lang-en">
    <Helmet>
      <title>Tang Wu Biotech</title>
      <meta
        name="description"
        content="Tang Wu Biotech offers premium food ingredient solutions with FSSC, HACCP, and ISO 22000 certifications for global catering brands."
      />
      <meta name="keywords" content="Tang Wu, food ingredients, FSSC, HACCP, ISO 22000" />
    </Helmet>
    <Home />
  </div>
);

export default Home_en;
